import { render, staticRenderFns } from "./progress-circle-component.vue?vue&type=template&id=20bc585d&scoped=true&"
import script from "./progress-circle-component.vue?vue&type=script&lang=ts&"
export * from "./progress-circle-component.vue?vue&type=script&lang=ts&"
import style0 from "./progress-circle-component.vue?vue&type=style&index=0&id=20bc585d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc585d",
  null
  
)

export default component.exports